<template>
  <div class="main-content">
    <the-header :title="t('Dashboard')" :buttons="headerButtons"/>
    <div class="row">
      <router-link :to="{name: 'patients', params: {page: 1}}"
                   class="col col-6 col-md-6 col-lg-3"
                   v-if="hasPermission('PatientsTitan', 'R')"
      >
        <dashboard-card :value="item.myPatients"
                        :text="t('My patients')"
        />
      </router-link>
      <div class="col col-6 col-sm-6 col-md-6 col-lg-3" v-if="hasPermission('ApplicationsTitan', 'R')">
        <dashboard-card :value="item.activeApplications"
                        :text="t('Active applications')"
                        card-class="bg-success"
        />
      </div>
      <div class="col col-6 col-md-6 col-lg-3" v-if="hasPermission('ApplicationsTitan', 'R')">
        <dashboard-card :value="item.notFinishedApplications"
                        :text="t('Not finished applications')"
                        card-class="bg-warning"
        />
      </div>
      <div class="col col-6 col-md-6 col-lg-3" v-if="hasPermission('ApplicationsTitan', 'R')">
        <dashboard-card :value="item.declinedApplications"
                        :text="t('Declined applications')"
                        card-class="bg-danger"
        />
      </div>
    </div>
    <div class="info" v-html="t('_textIntroDashboard')"></div>

    <template v-if="hasPermission('ApplicationsTitan', 'R')">
      <h2 class="h2">{{t('Latest applications')}}</h2>
      <grid :hidePaginator="true"
            :showPatient="true"
            :sortable="false"
            @updated="initReport()"
      />
      <div class="text-center">
        <router-link :to="{name: 'applications', params: {page: 1}}" class="btn btn-outline-secondary">
          {{t('Show all applications')}}
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
    import TheHeader from '../../admin/Layout/TheHeader'
    import DashboardCard from '../../admin/Components/Dashboard/DashboardCard';
    import Grid from './applications/grid';
    import FileUpload from './applications/file-upload';
    import {apiLink} from '../../store/api'

    export default {
        components: {
            FileUpload,
            DashboardCard,
            TheHeader,
            Grid,
        },
        created() {
            this.initReport();
        },
        methods: {
            initReport() {
                this.$store.dispatch('reports/dashboard').then(res => {
                    this.item = res;
                });
            }
        },
        data() {
            return {
                headerButtons: [
                    {
                        type: 'link',
                        to: () => {
                            const user = this.$store.state.account.user;
                            const hash = user.hash === undefined ? '' : user.hash;
                            return apiLink() + 'file/personal-data-processing/' + hash;
                        },
                        target: '_blank',
                        name: this.t('GDPR file download'),
                        icon: 'cloud-download-alt',
                        styleClass: 'btn-primary'
                    }
                ],
                item: {
                    activeApplications: 0,
                    declinedApplications: 0,
                    myPatients: 0,
                    notFinishedApplications: 0,
                }
            }
        }
    }
</script>
<style lang="scss">
  .info {
    display: block;
    font-size: 0.9em !important;
    color: gray;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/private/Dashboard.vue